<section class="screen-boundary">
  <router-outlet></router-outlet>
  <ngx-loading-bar [color]="loadingBarColor"></ngx-loading-bar>
  <!--<itorum-call-acceptor></itorum-call-acceptor>-->
  <itorum-video-call-container></itorum-video-call-container>
</section>
